import React from "react";
interface props {
  className?: string;
}

function WindowAboutus({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      className={className}
      fill="none"
      viewBox="0 0 60 60"
    >
      <path
        fill="#5D5FEF"
        d="M24.375 24.375V48.75h-15A1.875 1.875 0 017.5 46.875v-22.5h16.875z"
        opacity="0.2"
      ></path>
      <path
        fill="#5D5FEF"
        d="M50.625 9.375H9.375a3.75 3.75 0 00-3.75 3.75v33.75a3.75 3.75 0 003.75 3.75h41.25a3.75 3.75 0 003.75-3.75v-33.75a3.75 3.75 0 00-3.75-3.75zm0 3.75V22.5H9.375v-9.375h41.25zM9.375 26.25H22.5v20.625H9.375V26.25zm41.25 20.625H26.25V26.25h24.375v20.625z"
      ></path>
    </svg>
  );
}

export default WindowAboutus;
